import axiosClient from "./axiosClient";

const siteApi = {

    search(params) {
        const url = '/site';
        return axiosClient.get(url, { params: params });
    },
    register(params) {
        return axiosClient.post("/site-new", params);
    },
    getDetails(params) {
        return axiosClient.get("/site/details", { params });
    },

}

export default siteApi;
